import { useState, useEffect } from 'react';

export const useCookieListener = (cookieName: string, intervalMs: number, isActive: boolean) => {
    const [cookieExists, setCookieExists] = useState(
        document.cookie.split('; ').some((c) => c.startsWith(`${cookieName}=`)),
    );

    useEffect(() => {
        if (!isActive) return;

        const intervalId = setInterval(() => {
            const exists = document.cookie.split('; ').some((c) => c.startsWith(`${cookieName}=`));
            if (exists !== cookieExists) {
                setCookieExists(exists);
            }
        }, intervalMs);

        return () => clearInterval(intervalId);
    }, [cookieExists, cookieName, intervalMs, isActive]);

    return cookieExists;
};

/* 
Como usar:
useCookieListener esta constantemente escuchando si existe una cookie, lo que ocupa recursos.
para limitar el uso de los recursos a lo estrictamente necesario se le pasa el parametro
"isActive" lo que activa el polling de la cookie y desactiva el polling si no es necesario.

Ej en un componente:

const [isPollingActive, setIsPollingActive] = useState(true);
    const [isDisabledByCookies, setIsDisabledByCookies] = useState(
        !!getCookie('cookie_1'),
    );
    const disabledCookieExist = useCookieListener(
        'cookie_1',
        1000,
        isPollingActive,
    );

    useEffect(() => {
        if (!disabledCybCookieExist) {
            setIsCybDisabledByCookies(false);
            setIsPollingActive(false); // como la cookie ya no existe se deja de esuchar
        }
    }, [disabledCybCookieExist]);

*/
